import { RouterModule, Routes } from "@angular/router";
// import { HomeComponent } from './pages/shared/home/home.component';
// import { CategoriaComponent } from './pages/shared/categoria/categoria.component';
// import { ProductoComponent } from './pages/shared/producto/producto.component';
// import { CotizacionComponent } from './pages/shared/cotizacion/cotizacion.component';
// import { FichaTecnicaComponent } from './pages/shared/ficha-tecnica/ficha-tecnica.component';
// import { ResultadoBusquedaComponent } from './pages/shared/resultado-busqueda/resultado-busqueda.component';
// import { EspecialesSfComponent } from './pages/shared/especiales-sf/especiales-sf.component';
// import { CategoriaEspecialComponent } from './pages/shared/categoria-especial/categoria-especial.component';
// import { BasePublicComponent } from './pages/shared/base-public/base-public.component';
import { BaseAdminComponent } from "./pages/admin/base-admin/base-admin.component";
import { LoginComponent } from "./pages/admin/login/login.component";
import { AdminSiteComponent } from "./pages/admin/admin-site/admin-site.component";
import { DestacadosHomeComponent } from "./pages/admin/destacados-home/destacados-home.component";
import { EspecialesPortadaComponent } from "./pages/admin/especiales-portada/especiales-portada.component";
import { SeleccionSfComponent } from "./pages/admin/seleccion-sf/seleccion-sf.component";
import { BannerEncuentralosComponent } from "./pages/admin/banner-encuentralos/banner-encuentralos.component";
import { MarcasComponent } from "./pages/admin/marcas/marcas.component";
import { BandInformacionComponent } from "./pages/admin/banda-informacion/banda-informacion.component";
import { PopupComponent } from "./pages/admin/popup/popup.component";
import { AdjuntoComponent } from "./pages/admin/adjunto/adjunto.component";
import { CategoriasComponent } from "./pages/admin/categorias/categorias.component";
import { CategoriasEspecialesComponent } from "./pages/admin/categorias-especiales/categorias-especiales.component";
import { CrearCategoriaEspecialComponent } from "./pages/admin/crear-categoria-especial/crear-categoria-especial.component";
// import { PreviewCategoriaEspecialComponent } from './pages/shared/preview-categoria-especial/preview-categoria-especial.component';
import { ListaProductosComponent } from "./pages/admin/lista-productos/lista-productos.component";
import { CrearProductoComponent } from "./pages/admin/crear-producto/crear-producto.component";
import { CargarCodigosComponent } from "./pages/admin/cargar-codigos/cargar-codigos.component";
import { DescargarListadoCodigosComponent } from "./pages/admin/descargar-listado-codigos/descargar-listado-codigos.component";
import { EspecialesComponent } from "./pages/admin/especiales/especiales.component";
import { ListadoCodigosComponent } from "./pages/admin/listado-codigos/listado-codigos.component";
import { CategoriasDocumentosComponent } from "./pages/admin/categorias-documentos/categorias-documentos.component";
import { ListadoFichasComponent } from "./pages/admin/listado-fichas/listado-fichas.component";
import { ListadoMarcasComponent } from "./pages/admin/listado-marcas/listado-marcas.component";
import { ListadoCertificacionesComponent } from "./pages/admin/listado-certificaciones/listado-certificaciones.component";
import { OrdenarProductosComponent } from "./pages/admin/ordenar-productos/ordenar-productos.component";
import { HistorialCambiosProductosComponent } from "./pages/admin/historial-cambios-productos/historial-cambios-productos.component";
import { DescargarProductosComponent } from "./pages/admin/descargar-productos/descargar-productos.component";
// import {PreviewProductoComponent} from './pages/shared/preview-producto/preview-producto.component';
import { AdminGuard } from "./guards/admin.guard";
// import { BasePublicComponent } from './pages/shared/base-public/base-public.component';
// import { HomeComponent } from './pages/shared/home/home.component';
// import { CategoriaComponent } from './pages/shared/categoria/categoria.component';
// import { ProductoComponent } from './pages/shared/producto/producto.component';
// import { CotizacionComponent } from './pages/shared/cotizacion/cotizacion.component';
// import { FichaTecnicaComponent } from './pages/shared/ficha-tecnica/ficha-tecnica.component';
// import { ResultadoBusquedaComponent } from './pages/shared/resultado-busqueda/resultado-busqueda.component';
// import { EspecialesSfComponent } from './pages/shared/especiales-sf/especiales-sf.component';
// import { CategoriaEspecialComponent } from './pages/shared/categoria-especial/categoria-especial.component';
// import { PreviewCategoriaEspecialComponent } from './pages/shared/preview-categoria-especial/preview-categoria-especial.component';
// import { PreviewProductoComponent } from './pages/shared/preview-producto/preview-producto.component';
import { CloseSessionComponent } from "./pages/admin/close-session/close-session.component";
import { DescuentosComponent } from "./pages/admin/descuentos/descuentos.component";
import { ConfiguracionComponent } from "./pages/admin/configuracion/configuracion.component";

const APP_ROUTES: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "administrador",
    // component: BasePublicComponent,
    // children: [
    //   {
    //     path: '',
    //     component: HomeComponent,
    //     data: {
    //       breadcrumb: 'Inicio'
    //     }
    //   }, {
    //     path: 'categoria/:padreId/:hijaId',
    //     component: CategoriaComponent,
    //     data: {
    //       breadcrumb: 'Categoria'
    //     }
    //   }, {
    //     path: 'producto/:id',
    //     component: ProductoComponent,
    //     data: {
    //       breadcrumb: 'Producto'
    //     }
    //   }, {
    //     path: 'cotizaciones',
    //     component: CotizacionComponent,
    //     data: {
    //       breadcrumb: 'Cotizacion'
    //     }
    //   }, {
    //     path: 'fichas-tecnicas',
    //     component: FichaTecnicaComponent,
    //     data: {
    //       breadcrumb: 'Descargar fichas'
    //     }
    //   }, {
    //     path: 'resultado-busqueda/:texto',
    //     component: ResultadoBusquedaComponent,
    //     data: {
    //       breadcrumb: 'Resultados de bùsqueda'
    //     }
    //   }, {
    //     path: 'especiales-start-fire',
    //     component: EspecialesSfComponent,
    //     data: {
    //       breadcrumb: 'Especiales Start Fire'
    //     }
    //   }, {
    //     path: 'categoria-especial/:id',
    //     component: CategoriaEspecialComponent,
    //     data: {
    //       breadcrumb: 'Categoria Especial'
    //     }
    //   }, {
    //     path: 'vista-previa-categoria-especial',
    //     component: PreviewCategoriaEspecialComponent,
    //     data: {
    //       requireLogin: true
    //     }
    //   }, {
    //     path: 'vista-previa-producto',
    //     component: PreviewProductoComponent,
    //     data: {
    //       requireLogin: true
    //     }
    //   }
    // ]
    // }, {
    //   path: 'administrador',
    //   component: LoginComponent,
  },

  {
    path: "administrador",
    component: BaseAdminComponent,
    children: [
      {
        path: "",
        component: LoginComponent,
      },
      {
        path: "close-session",
        component: CloseSessionComponent,
      },
      {
        path: "admin-sitio",
        component: AdminSiteComponent,
        data: {
          requireLogin: true,
        },
        children: [
          {
            path: "home-destacados",
            component: DestacadosHomeComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "especiales-portada",
            component: EspecialesPortadaComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "seleccion-start-fire",
            component: SeleccionSfComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "banner-encuentralos",
            component: BannerEncuentralosComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "marcas",
            component: MarcasComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "popup",
            component: PopupComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "banda-informacion",
            component: BandInformacionComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "adjuntos",
            component: AdjuntoComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "categorias",
            component: CategoriasComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "categorias-especiales",
            component: CategoriasEspecialesComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "crear-categoria-especial/:id",
            component: CrearCategoriaEspecialComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "listado-productos",
            component: ListaProductosComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "ordenar-productos",
            component: OrdenarProductosComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "historial-cambios-productos",
            component: HistorialCambiosProductosComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "descargar-productos",
            component: DescargarProductosComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "crear-productos",
            component: CrearProductoComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "cargar-codigos",
            component: CargarCodigosComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "listado-codigos",
            component: ListadoCodigosComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "descargar-listado-codigos",
            component: DescargarListadoCodigosComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "especiales",
            component: EspecialesComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "descuentos",
            component: DescuentosComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "configuracion",
            component: ConfiguracionComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "categorias-documentos",
            component: CategoriasDocumentosComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "listado-fichas",
            component: ListadoFichasComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "listado-marcas",
            component: ListadoMarcasComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
          {
            path: "listado-certificaciones",
            component: ListadoCertificacionesComponent,
            canActivate: [AdminGuard],
            data: {
              requireLogin: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "**",
    pathMatch: "full",
    redirectTo: "/",
  },
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, { useHash: true });



// WEBPACK FOOTER //
// /app/src/app/app.routes.ts